import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./SubscriptionModal.css";
import btnArrow from "../assets/icons/btn_arrow.svg";

const SubscriptionModal = ({ show, onHide }) => {
  const navigate = useNavigate();

  const handleNavigateToSubscription = () => {
    if (onHide) onHide();
    navigate("/subscription");
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="subscription-modal-wrapper"
      contentClassName="subscription-modal-content"
    >
      <div className="subscription-modal-body">
        {/* Close Button */}
        <button
          type="button"
          className="btn-close subscription-modal-close"
          onClick={onHide}
          aria-label="Close modal"
        />

        {/* Top Decorative Badge */}
        <div className="subscription-modal-badge">
          <span className="subscription-modal-badge-icon">🌿</span>
          <span className="subscription-modal-badge-text">
            Special Monthly Offer
          </span>
        </div>

        {/* Header Title */}
        <h2 className="subscription-modal-title">
          You are now eligible for the <em>Monthly Subscription!</em>
        </h2>

        {/* Subtitle */}
        <p className="subscription-modal-subtitle">
          Continue your healing journey with monthly practitioner reviews, custom formula adjustments, and continuous personalized herbal shipments.
        </p>

        {/* Highlights Card */}
        <div className="subscription-modal-card">
          <div className="subscription-modal-price-row">
            <div className="subscription-modal-price">
              <span className="subscription-modal-price-symbol">$</span>
              <span className="subscription-modal-price-val">149</span>
              <span className="subscription-modal-price-unit">/ month</span>
            </div>
            <span className="subscription-modal-cancel-note">Cancel anytime</span>
          </div>

          <ul className="subscription-modal-benefits">
            <li>
              <span className="benefit-icon">🌿</span>
              <span>
                <strong>Monthly Practitioner Review</strong> &amp; formula updates
              </span>
            </li>
            <li>
              <span className="benefit-icon">📦</span>
              <span>
                <strong>Personalized Herbal Shipment</strong> delivered every month
              </span>
            </li>
            <li>
              <span className="benefit-icon">💻</span>
              <span>
                <strong>Dashboard &amp; Care Access</strong> with full formula history
              </span>
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="subscription-modal-actions">
          <button
            id="subscription-modal-navigate-btn"
            className="subscription-modal-cta"
            onClick={handleNavigateToSubscription}
          >
            <span>View Subscription Detail</span>
            <img src={btnArrow} alt="" width="18" height="18" className="btn-arrow-img" />
          </button>

          <button
            type="button"
            className="subscription-modal-dismiss"
            onClick={onHide}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SubscriptionModal;
